<script setup lang="ts">
defineEmits(["doSearch"]);
const searchTerm = defineModel("searchTerm", {
  type: String,
  default: "",
});
</script>
<template>
  <div
    class="flex flex-col items-center justify-center px-8 py-4 border-b border-secondary-500">
    <form
      class="relative h-[42px] rounded-lg bg-primary-900 flex items-center w-full"
      @submit.prevent="$emit('doSearch')">
      <NuxtIcon
        name="mdi:search"
        class="absolute left-4 h-5 w-5 shrink-0 text-neutral-300"
        aria-hidden="true" />
      <input
        v-model="searchTerm"
        class="pl-12 text-neutral-300 placeholder:text-neutral-300 w-full h-full px-4 rounded-lg bg-inherit border-primary-500 border-r-0 focus:ring-transparent focus:border-primary-500"
        type="text"
        placeholder="Search"
        autocomplete="off"
        data-1p-ignore
        data-lpignore="true"
        data-test="input-filter-search" />
    </form>
  </div>
</template>
